import { useQuery } from '@tanstack/react-query'
import { getSalesforceDeals } from '@/lib/apiClients/salesforce'
import { queryKeys } from '@/lib/queryKeys'

export function useSalesforceDeals(salesforceCustomerId: number | undefined) {
  return useQuery({
    queryKey: queryKeys.salesforceDeals(salesforceCustomerId),
    queryFn: async () => {
      if (salesforceCustomerId === undefined) throw new Error('salesforceCustomerId is required')
      return getSalesforceDeals(salesforceCustomerId)
    },
    enabled: salesforceCustomerId !== undefined,
  })
}
